var en = require('i18n/en.json');
var nb = require('i18n/nb.json');
var sv = require('i18n/sv.json');
var fr = require('i18n/fr.json');

var moment = require('moment');

var fallbackLanguage = 'en';
var language = fallbackLanguage;
var translations = { en: en, nb: nb, sv: sv, fr: fr };

module.exports.getLanguage = function() {
  return language;
};

module.exports.setLanguage = function(lang) {
  //console.log('translate.setLanguage('+lang+')');
  language = lang;

  moment.locale(lang); // Keep i18n-locale in moment-lib in sync
};

module.exports.t = function(key) {
  //console.log('translate t', language, key);
  var output = translations[language][key];
  if (output && arguments.length > 1) {
    for (i=1; i<arguments.length; i++) {
      output = output.replace(new RegExp('%'+i, 'g'), arguments[i]);
    }
  }
  return (output == null? '{'+key+'}' : output);
};

module.exports.tu = function(key) {
  return t(key).toUpperCase();
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/translate.js
 ** module id = 4
 ** module chunks = 1
 **/